import { Component, Inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatTableCrudEditComponent } from "../../../shared/components/mat-table-crud/mat-table-crud-edit.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { LoggerService } from "../../../shared/services/logger.service";
import { DayPart } from "../administration.models";
import { AdministrationService } from '../administration.service';

import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";


@Component({
  templateUrl: './daypart-edit.component.html',
  selector: 'daypart-edit-form',
  styleUrls: ['../../../shared/components/mat-table-crud/mat-table-crud.component.scss', './dayparts.component.scss'],
  providers: [MatTableCrudService],
  standalone: true,
  imports: [CdkDrag, FormsModule, ReactiveFormsModule, CdkDragHandle, MatDialogTitle, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDialogActions, MatButtonModule]
})
export class DayPartEditComponent extends MatTableCrudEditComponent<DayPartEditComponent, DayPart>
{
  constructor(public fb: UntypedFormBuilder, public dialogRef: MatDialogRef<DayPartEditComponent>, @Inject(MAT_DIALOG_DATA) public data: DayPart, public administrationService: AdministrationService, public authorisationService: AuthorisationService, public loggerService: LoggerService)
  {
    super(dialogRef, data);

    this.form = this.fb.group({
      Id: [this.data.Id],
      DayPartName: [this.data.DayPartName, Validators.required],
      DayPartLabel: [this.data.DayPartLabel, Validators.required],
      Disabled: [this.data.Disabled],
      SortOrder: [this.data.SortOrder, Validators.compose([Validators.required, Validators.pattern('^\\d+$')])]
    });

  }

  ngOnInit()
  {
    super.ngOnInit();

  }

  onSave(): void
  {
    const dayPart: any = this.form.value;

    if (dayPart)
    {
      if (this.isNew)
      {
        dayPart.Id = 0;

        if (dayPart.Disabled == null)
        {
          dayPart.Disabled = false;
        }
      }

      dayPart[this.changedByField] = this.authorisationService.currentuser.Id;

      super.onSave(dayPart);
    }
  }

  get dialogHeaderText(): string
  {
    let headerText = "Edit DayPart";

    if (this.isNew)
    {
      headerText = "New DayPart";
    }
    else
    {
      if (this.showEditItemNameInHeaderText)
      {
        headerText = `${headerText} - ${this.data.DayPartName}`;
      }
    }

    return headerText;
  }




  ngOnDestroy()
  {
    super.ngOnDestroy();

  }



}
